var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.069 23.137a8.069 8.069 0 100-16.137 8.069 8.069 0 000 16.137zM27.069 45.856a8.069 8.069 0 100-16.137 8.069 8.069 0 000 16.137zM27.069 69a8.069 8.069 0 100-16.137 8.069 8.069 0 000 16.137zM49.363 23.137a8.068 8.068 0 100-16.137 8.068 8.068 0 000 16.137zM49.363 45.856a8.068 8.068 0 100-16.137 8.068 8.068 0 000 16.137zM49.363 69a8.068 8.068 0 100-16.137 8.068 8.068 0 000 16.137z",
    fill: "#79B41C"
  })));
}
export default __webpack_public_path__ + "static/media/Drag.e70b3f19.svg";
export { SvgDrag as ReactComponent };